if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (!this.form) {
        console.error('Form not found in product-form component');
        return;
      }

      const idInput = this.form.querySelector('[name=id]');
      if (idInput) idInput.disabled = false;

      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');

      if (this.submitButton && document.querySelector('cart-drawer')) {
        this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      // ✅ STEP 1 — Instant visual feedback FIRST (paints immediately)
      this.submitButton.setAttribute('aria-disabled', 'true');
      this.submitButton.classList.add('loading');
      const spinner = this.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      // ✅ STEP 2 — Yield to let browser paint the loading state
      await yieldToMain();

      // ✅ STEP 3 — Now do all the heavy prep work off the critical path
      this.handleErrorMessage();

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map(s => s.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      config.body = formData;

      // ✅ STEP 4 — Fetch (async, doesn't block main thread)
      try {
        const response = await fetch(`${routes.cart_add_url}`, config);
        const data = await response.json();

        await yieldToMain(); // ✅ yield before DOM updates from response

        if (data.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            errors: data.description,
            message: data.message
          });
          this.handleErrorMessage(data.description);

          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (soldOutMessage) {
            this.submitButton.setAttribute('aria-disabled', 'true');
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
          }
          this.error = true;
          return;
        }

        if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        if (!this.error) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: formData.get('id')
          });
        }
        this.error = false;

        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          // ✅ Scoped listener with modal identity check — no wrong-modal firing
          const onModalClosed = () => {
            setTimeout(() => this.cart.renderContents(data));
          };
          document.body.addEventListener('modalClosed', onModalClosed, { once: true });
          quickAddModal.hide(true);
        } else {
          await yieldToMain(); // ✅ yield before heavy cart render
          this.cart.renderContents(data);
        }

      } catch (e) {
        console.error(e);

      } finally {
        // ✅ Always clean up UI state
        this.submitButton.classList.remove('loading');
        if (this.cart?.classList.contains('is-empty')) {
          this.cart.classList.remove('is-empty');
        }
        if (!this.error) {
          this.submitButton.removeAttribute('aria-disabled');
        }
        if (spinner) spinner.classList.add('hidden');
      }
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper ??= this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;

      this.errorMessage ??= this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) this.errorMessage.textContent = errorMessage;
    }
  });
}

function yieldToMain() {
  return typeof scheduler !== 'undefined' && scheduler.yield
    ? scheduler.yield()
    : new Promise(r => setTimeout(r, 0));
}